<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<p class="bkpub1"><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span><img alt="" height="175" src="images/hayek_crest.jpeg" width="116"/></p>
<p class="sert" style="text-align:center;">The Collected Works of F. A. Hayek</p>
<p class="sers" style="text-align:center;">Volume XIX</p>
<h1 class="bk" style="margin-top:1em;">Law, Legislation, and Liberty</h1>
<h1 class="bk1">A New Statement of the Liberal Principles of Justice and Political Economy</h1>
<h1 class="bk2"><span class="sm">VOLUME</span> <span class="sm">1</span> Rules and Order</h1>
<h1 class="bk2"><span class="sm">VOLUME</span> <span class="sm">2</span> The Mirage of Social Justice</h1>
<h1 class="bk2"><span class="sm">VOLUME</span> <span class="sm">3</span> The Political Order of a Free People</h1>
<p class="bkau">Edited by Jeremy Shearmur</p>
<p class="bkpub"><img alt="" height="75" src="images/new-press-logo.jpeg" width="56"/></p>
<p class="bkpub1">The University of Chicago Press</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hayek-vol19-0004.vue?0b51d00b